// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tags_ray5g {
  display: flex;
  gap: 5px;
}

.tag_N886S {
  text-align: center;
  color: var(--white-color);
  width: fit-content;
  border-radius: 999px;
  display: block;
  height: 20px;
  width: 20px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  margin-left: -20px;
  cursor: pointer;
}

.tag_N886S:nth-child(1) {
  margin-left: 0;
}


.selected_hGcSx {
  border: 3px solid rgb(104, 104, 104) !important;
  transform: scale(1.2);
  transition: transform 0.2s ease-in-out;
  -webkit-transition: transform 0.2s ease-in-out;
  -moz-transition: transform 0.2s ease-in-out;
  -ms-transition: transform 0.2s ease-in-out;
  -o-transition: transform 0.2s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CircleTagsComponent/CircleTagsComponent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,sCAAsC;EACtC,8CAA8C;EAC9C,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;AAC3C","sourcesContent":[".tags {\n  display: flex;\n  gap: 5px;\n}\n\n.tag {\n  text-align: center;\n  color: var(--white-color);\n  width: fit-content;\n  border-radius: 999px;\n  display: block;\n  height: 20px;\n  width: 20px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  margin-left: -20px;\n  cursor: pointer;\n}\n\n.tag:nth-child(1) {\n  margin-left: 0;\n}\n\n\n.selected {\n  border: 3px solid rgb(104, 104, 104) !important;\n  transform: scale(1.2);\n  transition: transform 0.2s ease-in-out;\n  -webkit-transition: transform 0.2s ease-in-out;\n  -moz-transition: transform 0.2s ease-in-out;\n  -ms-transition: transform 0.2s ease-in-out;\n  -o-transition: transform 0.2s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tags": `tags_ray5g`,
	"tag": `tag_N886S`,
	"selected": `selected_hGcSx`
};
export default ___CSS_LOADER_EXPORT___;
